import type { ButtonProps } from '@mui/material/Button';
import type { EnterPressHandler, UseFocusableConfig } from '@noriginmedia/norigin-spatial-navigation';
import useFocusItem from 'hooks/useFocusItem';
import { FC, useCallback } from 'react';
import classNames from 'utils/classNames';
import { StyledButton } from './MaterialButton.styles';

interface MaterialButtonProps extends ButtonProps<'button'> {
  focusableConfig?: UseFocusableConfig;
  autoFocus?: boolean;
  onClick?: () => void;
}

const MaterialButton: FC<MaterialButtonProps> = ({ children, focusableConfig, onClick, ...props }) => {
  const onEnterPress = useCallback<EnterPressHandler>(
    (extraProps, details) => {
      onClick?.();
      focusableConfig?.onEnterPress?.(extraProps, details);
    },
    [focusableConfig, onClick],
  );
  const { ref, focused } = useFocusItem({
    ...focusableConfig,
    onEnterPress,
  });

  return (
    <StyledButton
      color="inherit"
      ref={ref}
      onClick={onClick}
      disableRipple={true}
      disableFocusRipple={true}
      disableTouchRipple={true}
      {...props}
      className={classNames(props.className, { 'nav-selected': focused })}
    >
      {children}
    </StyledButton>
  );
};

export default MaterialButton;
